import * as Sentry from '@sentry/react';
import client from 'utils/client';
import smoothScroll from '../utils/smoothScroll';
import impressionTracking from './impressionTracking';
import fetchAndHandleColorway from './components/colorways/actions';
import { IMAGE_CONTROLLER } from './components/gallerySlider/galleryActions';

export const INITIAL_DATA = initialData => dispatch => {
  dispatch({ type: 'INITIAL_DATA', initialData });
};

export const ADD_SIZE = sizeDetails => dispatch => {
  dispatch({ type: 'ADD_SIZE', sizeDetails });
};

export const UPDATE_AMOUNT = (amount, discount) => dispatch => {
  dispatch({ type: 'UPDATE_AMOUNT', payload: { amount, discount } });
};

export const SCREEN_RESIZE = width => dispatch => {
  dispatch({ type: 'SCREEN_RESIZE', width });
};

export const PRICE_MATCH = () => dispatch => {
  let text = '';
  if (window.getSelection) {
    text = window.getSelection();
  } else if (document.getSelection) {
    text = document.getSelection();
  } else if (document.selection) {
    // eslint-disable-next-line prefer-destructuring
    text = document.selection.createRange().text;
  }
  text = text.toString();
  dispatch({ type: 'PRICE_MATCH', text });
};

export const SIZE_NOT_PICKED = message => dispatch => {
  dispatch({ type: 'SIZE_NOT_PICKED', payload: { message } });
};

export const ADD_UNIID_LINK = url => dispatch => {
  dispatch({ type: 'ADD_UNIID_LINK', payload: url });
};

export const ADD_CUSTOMIZATION_LIST =
  (customizationList, allData) => dispatch => {
    return dispatch({
      type: 'ADD_CUSTOMIZATION_LIST',
      customizationList,
      allData
    });
  };

export const SELECTING_CUSTOMIZATION = (isOpen, productID, lineID) => {
  return {
    type: 'SELECTING_CUSTOMIZATION',
    payload: isOpen,
    productID,
    lineID
  };
};

export const UNSELECT_CUSTOMIZATION = unselect => {
  return {
    type: 'UNSELECT_CUSTOMIZATION',
    payload: unselect
  };
};

export const CLEAR_CUSTOMIZATION = () => {
  return {
    type: 'CLEAR_CUSTOMIZATION'
  };
};

const updateMeta = data => {
  const { title, description, canonical } = data.meta;
  document.querySelector('title').innerText = title;
  document.querySelector('.twitter-title').content = title;
  document.querySelector('.og-title').content = title;
  document.querySelector('.og-canonical').content = canonical;
  document.querySelector('.meta-canonical').href = canonical;
  document.querySelector('.twitter-image').content =
    data.images.gallery[0].image;
  document.querySelector('.og-image').content = data.images.gallery[0].image;
  document.querySelector('.meta-style').content = data.style;
  if (window.Clerk) {
    const clerk = document.querySelector('.clerk');
    const parent = clerk.parentElement;
    parent.removeChild(clerk);
    const newClerk = document.createElement('span');
    newClerk.classList.add('clerk');
    newClerk.dataset.api = 'log/product';
    newClerk.dataset.product = data.product_id;
    parent.appendChild(newClerk);
    window.Clerk.renderBlocks('.clerk');
  }

  const metaGroups = ['meta', 'twitter', 'og'];
  metaGroups.forEach(group => {
    document.querySelector(`.${group}-description`).content = description;
  });

  try {
    const links = document.querySelectorAll('link');
    const hrefLinks = Array.prototype.filter.call(links, link =>
      link.getAttribute('hreflang')
    );
    hrefLinks.forEach(link => {
      data.meta.hreflangs.href_data.forEach(newHrefLang => {
        const [newLang, newLink] = newHrefLang;
        if (newLang === link.hreflang) {
          // eslint-disable-next-line no-param-reassign
          link.href = newLink;
        }
      });
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  const schemaEl = document.querySelector('.json-schema');
  schemaEl.innerText = data.json_schema;
};

export const FETCH_AND_REPLACE_STATE = product => (dispatch, getState) => {
  dispatch({ type: 'FETCHING_AND_REPLACING_STATE' });
  // Unfortunately have to make quite a few requests to fetch everything.
  return client
    .get(product.relative_url)
    .then(res => {
      dispatch(fetchAndHandleColorway(res.data.product_id)).then(() => {
        const productData = {
          id: res.data.product_id,
          min_price: res.data.prices.min_price,
          max_price: res.data.prices.max_price,
          rrp: res.data.prices.recommended_retail_price,
          currency: res.data.prices.currency,
          online: !res.data.cannot_buy_online,
          sizes: res.data.sizes
        };
        updateMeta(res.data);
        window.__INITIAL_STATE__ = res.data;
        window.history.replaceState({}, '', product.relative_url);
        impressionTracking(res.data, productData);
        dispatch({ type: 'FETCH_AND_REPLACE_STATE', newState: res.data });
        const state = getState();
        smoothScroll('aboveFold', 120);
        if (state.general.isMobile) {
          state.gallery.mobileSlider.slickGoTo(0, true);
        } else if (state.general.isTablet) {
          state.gallery.tabletSlider.slickGoTo(0, true);
        } else {
          state.gallery.desktopSlider.slickGoTo(0, true);
        }
        dispatch(IMAGE_CONTROLLER(0));
      });
    })
    .catch(() => {
      // Fail to get new state
    });
};
